import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoSection() {
  return <section className="py-24 px-6 bg-white" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-167">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-teal-50 p-8 rounded-2xl border border-teal-100" data-id="element-168">
            <h3 className="text-xl font-bold text-teal-900 mb-6 flex items-center gap-2" data-id="element-169">
              <CheckCircle2 className="w-6 h-6 text-teal-600" data-id="element-170" />
              This is for you if:
            </h3>
            <ul className="space-y-4" data-id="element-171">
              {["You're capable, busy, and privately overwhelmed.", "You want something practical you can do even when you're fried.", "You need a solution that doesn't require taking a month off work.", "You're tired of 'mindset' advice that ignores your body."].map((item, i) => <li key={i} className="flex items-start gap-3 text-teal-800" data-id="element-172">
                  <span className="block w-1.5 h-1.5 mt-2 rounded-full bg-teal-400 flex-shrink-0" data-id="element-173" />
                  <span className="leading-relaxed" data-id="element-174">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-175">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-176">
              <XCircle className="w-6 h-6 text-slate-400" data-id="element-177" />
              This is NOT for you if:
            </h3>
            <ul className="space-y-4" data-id="element-178">
              {["You want a 'one weird trick' miracle cure.", "You're looking for a 45-minute deep meditation practice.", "You're currently in a crisis that requires urgent professional therapy.", "You want to 'manifest' calm without doing the physical work."].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-600" data-id="element-179">
                  <span className="block w-1.5 h-1.5 mt-2 rounded-full bg-slate-300 flex-shrink-0" data-id="element-180" />
                  <span className="leading-relaxed" data-id="element-181">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}